import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { onSessionExpired } from './lib/session';
import { dashboardSocket } from './lib/ws';
import router from './router';
import { useAuthStore } from './stores/auth';
import { useUiStore } from './stores/ui';
import './styles.css';

/**
 * Dashboard entrypoint.
 *
 * The session-expired handler is wired here rather than inside `lib/api.ts` so
 * the HTTP layer never imports the router — the router imports the stores, which
 * import the HTTP layer, and closing that loop would be a cycle.
 */

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

onSessionExpired(() => {
  // The refresh token is gone or was rejected. Drop every trace of the session,
  // close the socket and route to /login with a return path.
  useAuthStore().forgetSession();
  dashboardSocket.disconnect();

  const ui = useUiStore();
  ui.reset();
  ui.notifyWarning('Phiên đăng nhập đã hết hạn', 'Vui lòng đăng nhập lại.');

  const current = router.currentRoute.value;
  if (current.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect: current.fullPath } });
  }
});

app.mount('#app');
